<template>
  <div>
    <div class="d-flex flex-wrap gap">
      <InformationCoureur :item="item"></InformationCoureur>
      <InfosFinanceInscription :inscription="item"></InfosFinanceInscription>
      <InfosEtatInscription :item="item"></InfosEtatInscription>
      <InfosCommande :item="item"></InfosCommande>
    </div>
  </div>
</template>

<script>
import InformationCoureur from "@/components/Administration/Edit_Inscriptions/Resume/InformationCoureur.vue";
import InfosFinanceInscription from "@/components/Administration/Edit_Inscriptions/InfosFinanceInscription.vue";
import InfosEtatInscription from "@/components/Administration/Edit_Inscriptions/Resume/InfosEtatInscription.vue";
import InfosCommande from "@/components/Administration/Edit_Inscriptions/Resume/InfosCommande.vue";
export default {
  components: {
    InformationCoureur,
    InfosFinanceInscription,
    InfosEtatInscription,
    InfosCommande,
  },
  props: ["item"],
};
</script>

<style lang="scss" scoped>
</style>